import { render, staticRenderFns } from "./shopping_record.vue?vue&type=template&id=793b2c4a&"
import script from "./shopping_record.vue?vue&type=script&lang=js&"
export * from "./shopping_record.vue?vue&type=script&lang=js&"
import style0 from "./shopping_record.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports